import * as React from 'react';
import {  IconButton, Modal } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { func_print } from '../../Func_genericas/func_print';
import { docs_cadernos } from '../../Func_genericas/hosts';
// type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;
interface Props {
    set_open_modal_show_pdf: React.Dispatch<boolean>,
    open_modal_show_pdf: boolean,
    link_file: string
}
export const Modalshowpdf = ({ open_modal_show_pdf, set_open_modal_show_pdf, link_file }: Props) => {
    //export const Modal_show_pdf = ( open_modal_show_pdf:boolean, set_open_modal_show_pdf: Dispatcher<boolean>, link_file:string ) => {
    func_print('link_file', link_file)
    return (
        <Modal
            style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            open={open_modal_show_pdf}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div style={{
                display: 'flex',
                //alignItems:'center',
                justifyContent: 'center',
                backgroundColor: 'white',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                flex: 1,
                marginLeft: '10%',
                marginRight: '10%',
                borderRadius: 5,
                /* paddingTop: '4%'  */
            }} >
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                }}>
                    <IconButton
                        onClick={() => { set_open_modal_show_pdf(false) }}
                    >
                        <CancelOutlinedIcon />
                    </IconButton>
                </div>
                <iframe 
                    src={ docs_cadernos +  link_file}
                    title=' '
                    height={'100%'} 
                    width={'100%'}>
                </iframe>
            </div>
        </Modal>
    )
}